// extracted by mini-css-extract-plugin
export var loadingSpinner = "_2f-0";
export var spinnerContainer = "_2f-1";